<div class="modal-body text-center">
  <span class="icon thumbs-up"></span> Tudo certo! O cliente realizou a etapa de
  Autenticação.
</div>
